import { useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PageHeader } from "../components/common";
import { api, formatErr, NICHES } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const F = ({ id, label, ...p }) => (
  <div className="space-y-1.5"><Label htmlFor={id} className="text-xs text-zinc-400">{label}</Label><Input id={id} data-testid={id} className="bg-zinc-900 border-zinc-800" {...p} /></div>
);

export default function Profile() {
  const { user, setUser, logout } = useAuth();
  const [p, setP] = useState({ name: user.name, email: user.email, phone: user.phone || "", niche: user.niche || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState("");

  const saveProfile = async (e) => {
    e.preventDefault(); setBusy("p");
    try { const { data } = await api.put("/auth/profile", p); setUser(data); toast.success("Perfil atualizado"); }
    catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(""); }
  };
  const changePw = async (e) => {
    e.preventDefault(); setBusy("pw");
    try { await api.post("/auth/change-password", pw); toast.success("Senha alterada"); setPw({ current_password: "", new_password: "" }); }
    catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(""); }
  };

  return (
    <div>
      <PageHeader eyebrow="Conta" title="Meu perfil" desc={`Plano ${user.plan_info?.name} • membro desde ${new Date(user.created_at).toLocaleDateString("pt-BR")}`} />
      <div className="grid lg:grid-cols-2 gap-4">
        <form onSubmit={saveProfile} className="card-lux p-5 space-y-4" data-testid="profile-form">
          <h3 className="font-bold">Dados pessoais</h3>
          <F id="profile-name-input" label="Nome" value={p.name} onChange={(e) => setP({ ...p, name: e.target.value })} required minLength={2} />
          <F id="profile-email-input" label="E-mail" type="email" value={p.email} onChange={(e) => setP({ ...p, email: e.target.value })} required />
          <F id="profile-phone-input" label="WhatsApp" value={p.phone} onChange={(e) => setP({ ...p, phone: e.target.value })} placeholder="(11) 99999-9999" />
          <div className="space-y-1.5"><Label className="text-xs text-zinc-400">Nicho</Label>
            <select className="field" value={p.niche} onChange={(e) => setP({ ...p, niche: e.target.value })} data-testid="profile-niche-select"><option value="">-</option>{NICHES.map((n) => <option key={n}>{n}</option>)}</select></div>
          <Button type="submit" className="btn-gold rounded-full w-full h-11" disabled={busy === "p"} data-testid="profile-save-button">{busy === "p" && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Salvar perfil</Button>
        </form>
        <div className="space-y-4">
          <form onSubmit={changePw} className="card-lux p-5 space-y-4" data-testid="password-form">
            <h3 className="font-bold">Alterar senha</h3>
            <F id="password-current-input" label="Senha atual" type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} required />
            <F id="password-new-input" label="Nova senha (mín. 6)" type="password" minLength={6} value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} required />
            <Button type="submit" variant="outline" className="rounded-full w-full h-11 border-amber-500/40 text-amber-300" disabled={busy === "pw"} data-testid="password-save-button">{busy === "pw" && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Alterar senha</Button>
          </form>
          <Button variant="ghost" className="w-full text-rose-400 hover:bg-rose-500/10" onClick={logout} data-testid="profile-logout-button"><LogOut className="h-4 w-4 mr-2" />Sair da conta</Button>
        </div>
      </div>
    </div>
  );
}
